import { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import styles from '../ScenarioGenerator.module.css';
import { ThreeDotsIcon } from '../../../common/selectIcons';

/** 3点メニュー：発音言語オプションを格納。
 * 話す速さは「読み方」(早口で / ゆっくりと) に一本化したため速度スライダーは置かない */
export function NarrationThreeDotMenu({
  narrationEnglish,
  setNarrationEnglish,
}: {
  narrationEnglish: boolean;
  setNarrationEnglish: (v: boolean) => void;
}) {
  const [open, setOpen] = useState(false);
  const btnRef = useRef<HTMLButtonElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  const [pos, setPos] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (!open) return;
    const handleClick = (e: MouseEvent) => {
      const target = e.target as Node;
      if (menuRef.current && !menuRef.current.contains(target) && btnRef.current && !btnRef.current.contains(target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  return (
    <>
      <button
        ref={btnRef}
        type="button"
        className={`${styles.threeDotButton} ${narrationEnglish ? styles.threeDotButtonActive : ''}`}
        onClick={() => {
          if (!open && btnRef.current) {
            const rect = btnRef.current.getBoundingClientRect();
            setPos({ top: rect.bottom + 4, left: rect.left });
          }
          setOpen(!open);
        }}
        title={narrationEnglish ? 'オプション（英語で発音: ON）' : 'オプション'}
      >
        <ThreeDotsIcon vertical />
      </button>
      {open && createPortal(
        <div
          ref={menuRef}
          className={`modal-surface ${styles.threeDotMenu}`}
          style={{ position: 'fixed', top: pos.top, left: pos.left }}
        >
          <div className={styles.threeDotMenuItem}>
            <label
              className={styles.threeDotMenuCheckbox}
              title="このシーンのナレーションテキストを英語として読み上げます（サウンドロゴなど）"
            >
              <input
                type="checkbox"
                checked={narrationEnglish}
                onChange={(e) => setNarrationEnglish(e.target.checked)}
              />
              英語で発音する
            </label>
          </div>
        </div>,
        document.body,
      )}
    </>
  );
}
